import Header from "@/components/header";
import Rules from "@/components/rules";
import { Container, Stack, Title } from "@mantine/core";

function TermsAndCondition() {
  return (
    <Stack mih="100svh" gap="0">
      <Header showHome title="قوانین و مقررات" showBack />
      <Container>
        <Stack px="lg" flex={1} mb="lg" mt="0" pt="0">
          <Title order={4}>قوانین و مقررات</Title>
          <Rules
          />
        </Stack>
      </Container>
    </Stack>
  );
}

export default TermsAndCondition;
